export const BOROUGHS = {
	MANHATTAN: 1,
	BRONX: 2,
	BROOKLYN: 3,
	QUEENS: 4,
	STATEN_ISLAND: 5,
};
